/// <reference types="vite/client" />
import * as Sentry from '@sentry/react';

const isProd = import.meta.env.MODE === 'production';

export const initSentry = (): void => {
  if (!isProd) return; // Only initialize in production

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    enableLogs: true,
    // Capture 10% of transactions for performance monitoring
    tracesSampleRate: 0.1,
    // Do NOT attach user PII to error reports
    beforeSend(event) {
      // Strip any user health data from error context before sending
      if (event.user) {
        delete event.user.email;
        delete event.user.ip_address;
      }
      return event;
    },
  });
};

export const captureError = (error: unknown, context?: Record<string, unknown>): void => {
  if (!isProd) return;
  Sentry.captureException(error, { extra: context });
};
